import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { ConversionErrorsClient, GetConversionError, GetConversionErrorDetail } from '../../generated-client/generated-client';
import { DatePipe, JsonPipe } from '@angular/common';

import { FileDownloadService } from '../../services/file-download.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'da-conversion-error-detail',
  templateUrl: './conversion-error-detail.component.html',
  styleUrls: ['./conversion-error-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, JsonPipe, DatePipe]
})
export class ConversionErrorDetailComponent implements OnInit {
  private conversionErrorsClient = inject(ConversionErrorsClient);
  private fileDownloadService = inject(FileDownloadService);
  conversionError = inject<GetConversionError>(MAT_DIALOG_DATA);

  conversionErrorDetail = signal<GetConversionErrorDetail>(null);
  conversionOptions = signal<unknown>(null);

  ngOnInit() {
    if (this.conversionError.id) {
      this.conversionErrorsClient.getConversionErrorDetailById(this.conversionError.id).subscribe(e => {
        this.conversionErrorDetail.set(e);
        if (e.conversionOptionsJson) {
          this.conversionOptions.set(JSON.parse(e.conversionOptionsJson));
        }
      });
    }
  }

  downloadFile() {
    this.fileDownloadService.downloadFile(this.conversionError.fileId);
  }
}
